<app-kontable #table id="dt_salesNetwork" title="{{ 'salesNetworkList.sectionTitle' | translate }}"
  [columns]="['id', 'code', 'name', 'description', 'logo_name', 'logo','sourceSystemName','company_host_code',
  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter }]"
  [titles]="['common.id', 'common.code', 'common.name', 'common.description', 'common.logo_name', 'common.logo','customerDetail.source_system','common.storeHostCode']"
  [showInfoButton]="false" [showRecoverButton]="false" [showGlobalFilter]="false" [showDetailsButton]="false"
  [showAddButton]="true" [source]="salesNetworks" (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)" (onRemove)="delete($event)" [(fireNewDataAvailable)]="newDataAvailable">

  <ng-template #stateTemplate data-testid="stateTemplate" let-row>
    <span *ngIf="row.flg_state && row.flg_state !== '0'" class="fa fa-trash-o" title="state"></span>
  </ng-template>

  <ng-template #stateFilter data-testid="stateFilter" let-col>
    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]"
      (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
  </ng-template>


</app-kontable>

<p-dialog *ngIf="show.dialog" [width]="500" [(visible)]="show.dialog" [responsive]="true" showEffect="fade"
  header="{{modalTitle}}" [modal]="true" (onHide)="onDialogHide()">
  <app-sales-network-form (salesNetworkAdded)="salesNetworkAdded($event)"
    (salesNetworkUpdated)="salesNetworkUpdated($event)"
    [dialogBoxSalesNetwork]="selectedSalesNetwork"></app-sales-network-form>
</p-dialog>


// WEBPACK FOOTER //
// ./src/app/views/administration/sales-network/sales-network.component.html